import { render, staticRenderFns } from "./CtrlChubunrui.vue?vue&type=template&id=4cebb594&"
import script from "./CtrlChubunrui.vue?vue&type=script&lang=ts&"
export * from "./CtrlChubunrui.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports